<template>
  <div>
    <ul class="main-menu">
      <!-- <li class>
        <menu-item name="help"
                   icon="fal fa-user-lock"
                   link="/lock"/>
      </li> -->
      <!-- <li class >
        <menu-item name="help"
                   icon="fal fa-life-ring"
                   link="#"/>
      </li> -->
      <!-- <li class @click="open=!open">
        <menu-item name="notification" icon="os-icon os-icon-bell" link="#"/>
      </li> -->
    </ul>

    <div :class="{'open':open}"
         class="tabs-notification">
      <tabs-notification/>
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/app/user/partials/navbar/web/mainMenu/MenuItem'
import MenuHeader from '@/components/app/user/partials/navbar/web/mainMenu/MenuHeader'
import TabsNotification from './tabs-notification.vue'
export default {
	name: 'right-menu',
	components: { TabsNotification, MenuItem, MenuHeader },
	data () {
		return {
			open: false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/rightMenu/index.vue